// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"97":"d5ac50cc","122":"b3ff1457","406":"243f6b37","513":"daf5cea1"}[chunkId] + ".css";
};